import { FC } from "react";

import { useGetTechnicianLogDetailsQuery } from "../../api/technicianLogApi";
import CircleButton from "../buttons/CircleButton";
import { FileResponseType } from "../../utils/types/api/FileType.ts";

type Props = {
  technicianLogId: string;
  onOpenFilesDialog: (files: FileResponseType, technicianLogId: string) => void;
};

export const TechnicianLogDetails: FC<Props> = ({
  technicianLogId,
  onOpenFilesDialog,
}) => {
  const { data: logData, isLoading } = useGetTechnicianLogDetailsQuery({
    technicianLogId,
  });

  const hasFiles = logData?.files?.length > 0;

  const handleFilesClick = () => {
    if (hasFiles) {
      onOpenFilesDialog(logData.files, technicianLogId);
    }
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (!logData) return;

  return (
    <div className="grid grid-cols-5 items-center mt-1 w-full font-medium text-xs">
      <p>{new Date(logData.date).toLocaleDateString()}</p>
      <p>{logData.technicianName}</p>
      <p>{logData.action}</p>
      <p>{logData.note || "-"}</p>
      <p className="flex items-center justify-between w-3/12 gap-2">
        {logData.files.length || "-"}
        {hasFiles && (
          <CircleButton
            icon="/images/preview.svg"
            primary
            iconSize="12px"
            onClick={handleFilesClick}
            disabled={false}
            className=""
          />
        )}
      </p>
    </div>
  );
};
